import gql from 'graphql-tag';

const CAMPAIGN_FRAGMENT = gql`
	fragment campaign on Campaign {
		id
		promotions {
			id
			name
		}
		name
		description
		isPaused
		autoDeactivateOnRestock
		notifyAppUsers
		notificationTitle
		notificationMessage
		startsAt
		endsAt
		applyToAll
		targetProducts {
			id
			name
		}
		usePromotionHours
		startHour
		endHour
		usePromotionDays
		promotionDays
		pointsOfSale {
			id
			assetId
			place {
				id
				name
			}
			commDevices {
				id
				deviceId
				secondaryId
			}
			location {
				id
				name
			}
		}
		pointsOfSaleCount
		basketCount
	}
`;

export const GET_CAMPAIGNS = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: CampaignPageFilter
	) {
		getCampaigns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...campaign
			}
			count
		}
	}
	${CAMPAIGN_FRAGMENT}
`;

export const GET_CAMPAIGNS_COUNT = gql`
	query {
		countCampaigns
	}
`;


export const CREATE_CAMPAIGN = gql`
    mutation createCampaignMutation($input: CreateCampaignInput!) {
        createCampaign(input: $input) {
            id
        }
    }
`;

export const DESTROY_CAMPAIGN = gql`
	mutation destroyCampaignMutation ($id: ID!) {
		destroyCampaign(id: $id)
	}
`;


export const GET_CAMPAIGN = gql`
	query($id: String) {
		getCampaign(id: $id) {
			...campaign
		}
	}
	${CAMPAIGN_FRAGMENT}
`;

export const MODIFY_CAMPAIGN = gql`
	mutation modifyCampaignMutation($input: ModifyCampaignInput!) {
		modifyCampaign(input: $input) {
			campaign {
				...campaign
			}
		}
	}
	${CAMPAIGN_FRAGMENT}
`;
